<template>
  <v-container justify-center class="text-xs-center mt-5 pt-5">
    <v-progress-circular
      :size="100"
      :width="15"
      color="purple"
      valvue="Loading"
      indeterminate
    ></v-progress-circular>
  </v-container>
</template>
<script>
import FirebaseModel from "../FirebaseService.js";

export default {
  data() {
    return {
      host: window.location.host,
      parts: window.location.host.split("."),
    };
  },
  mounted: async function () {
    if (this.$route.query.loginToken) {
      this.user = await FirebaseModel.getAuthInfo(this.$route.query.loginToken);
      console.log(this.user);
      console.log(process.env);
      localStorage.setItem(
        process.env.VUE_APP_LOCAL_STORAGE,
        JSON.stringify({ data: this.user })
      );
      localStorage.setItem("CLIENT_ID", this.$route.query.team);
      this.$router.push("/");
    } else {
      this.redirectToSso();
    }
  },
  methods: {
    redirectToSso() {
      let $host = window.location.host;
      window.location = process.env.VUE_APP_ONEAPP_DOMAIN;
    },
    async authenticateToken() {
      let $response = await FirebaseModel.firebaseAuth({
        token: this.$route.query.token,
      });
      if ($response.data.length == 1) {
        this.redirectToApp($response.data[0].team, $response.data[0].token);
      } else {
      }
    },
    redirectToApp($team, $token) {
      if (this.host.indexOf("localhost") >= 0) {
        this.$router.push("/logincompany?loginToken=" + $token);
      } else {
        window.location =
          "https://" +
          $team +
          "." +
          this.parts[this.parts.length - 2] +
          "." +
          this.parts[this.parts.length - 1] +
          "/logincompany?loginToken=" +
          $token;
      }
    },
  },
};
</script>
